import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import Breadcrumb from "../Components/BreadCrumb/Breadcrumb";
import CheckoutInner from "../Components/Shop/CheckoutInner";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function Checkout() {
  return (
    <>
      <Helmet>
        <title>Checkout | Howly Wizard</title>
      </Helmet>
      <HeaderOne />
      <CheckoutInner />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Checkout;
